import styled from 'styled-components'

export const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;
    align-items: center;
    width: 100%;
    margin-top: 50px;
`

export const Central = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(50px, 400px));
    grid-gap: 10px;
    margin: 0 auto;
    margin-bottom:50px;
    
`

export const CountdownContainer = styled.div`
    text-align: center;
    margin-top: 50px;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr;
    border-right: 2px solid #45B283;

    &:last-child{
        border-right: none;
    }

    @media (max-width: 500px){
        border-right: none;

    }
`

export const Number = styled.div`
    font-size: 50px;
    font-weight: 700;
    transition: all 0.2 ease-in;
    color: #1F94C2;

    &:hover{
        transform: scale(1.2);
        
    }
`

export const Text = styled.div`
    font-size: 16px;
    font-weight: 500;
   

`